import React, { useState } from 'react';
import styles from './RefundCreditAmount.module.css';
import { useDispatch } from 'react-redux';
import { closeModal } from '../../../redux/slices/modalSlice';
import { FaUserPlus } from 'react-icons/fa';
import SearchBar from '../../../components/SearchBar/SearchBar';
import Dropdown from '../../../components/Dropdown/Dropdown';

import HeadingAndData from '../../../components/HeadingAndData/HeadingAndData';
import HeadingAndDropDown from '../../../components/HeadingAndDropDown/HeadingAndDropDown';
import SaveAndCancel from '../../../components/SaveAndCancel/SaveAndCancel';
import ToClose from '../../../components/ToClose/ToClose';
import HeadingAndIcon from '../../../components/HeadingAndIcon/HeadingAndIcon';
import CheckboxAndData from '../../../components/CheckboxAndData/CheckboxAndData';
import CalendarInput from '../../../components/CalendarInput/CalendarInput';
import { IoDocumentTextOutline } from 'react-icons/io5';

const RefundCreditAmount = () => {
  const dispatch = useDispatch();

  const [form, setForm] = useState({
    amount: '',
    date: '',
    approvedBy: '',
    description: '',
    sendToParent: false,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSave = () => {
    dispatch(closeModal());
  };

  const handleCancel = () => dispatch(closeModal());

  const handleCheckbox = (e) => {
    setForm((prev) => ({ ...prev, sendToParent: e.target.checked }));
  };

  return (
    <div className={styles.modalWrapper}>
      <div className={styles.totaldata}>
        <div className={styles.subheading}>
          <HeadingAndIcon
            icon={<IoDocumentTextOutline />}
            heading="Credit Details"
            color="var(--Primary_Color)"
          />
          <ToClose onClose={() => dispatch(closeModal())} />
        </div>

        <div className={styles.content}>
          <div className={styles.reasonWrapper}>
            <CalendarInput
              fieldLabel="Date"
              required
              value={form.date}
              onChange={(date) => setForm((prev) => ({ ...prev, date }))}
            />
          </div>

          <div className={styles.reasonWrapper}>
            <HeadingAndData
              label="Refund Amount"
              name="amount"
              placeholder="0.00"
              value={form.amount}
              onChange={handleChange}
              required
            />
          </div>

          <div className={styles.reasonWrapper}>
            <label className={styles.reasonLabel} htmlFor="description">
              Reason
            </label>
            <textarea
              id="description"
              name="description"
              placeholder="Description"
              className={styles.textareaField}
              value={form.description}
              onChange={handleChange}
            />
          </div>

          <div className={styles.bottomRow}>
            <SaveAndCancel
              onSave={handleSave}
              onCancel={handleCancel}
              saveLabel={'Record Refund'}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default RefundCreditAmount;
